<template>
  <form class="uploader" ref="form">
    <input ref="file" @change="change" type="file" :accept="accept" :multiple="multiple">
  </form>
</template>

<script>
import {debug, getFileExt} from "../lib/util"
import weuijs from "weui.js"
import readFile from "../utils/readfile"
import api from "../lib/api"
import uploadApi from "@/lib/uploadApi";
import {systemService} from "@/services/system";
import * as qiniu from 'qiniu-js'

export default {
  name: 'v-uploader',
  props: {
    accept: {
      type: String,
      default: "image/*"
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attaModelType: "",
      files: null
    };
  },
  computed: {},
  components: {},
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    qiniuUplaod(file, token) {
      let ext = getFileExt(file);
      let key = hex_md5(Date.now() + '') + `.${ext}`;
      const observable = qiniu.upload(file, key, token);
      return new Promise((resolve, reject) => {
        const subscription = observable.subscribe({
          next(res) {
            Log('next', res)
          },
          error(error) {
            Log('error', error)
          },
          complete(res) {
            Log('complete', res);
            resolve(res);
          }
        });
      })
    },

    click(attaModelType) {
      if (attaModelType) this.attaModelType = attaModelType;
      let dom = this.$refs.file;
      this.$nextTick(() => {
        dom.click();
      })
    },

    change() {
      let dom = this.$refs.file, files = dom.files;
      debug("file", files);
      this.files = files;
      //this.upload(files);
      if (files.length > 0)
        this.$zhe2dialog.uploadScan(files)
          .then(data => {
            Log('confirm,data', data);
            this.upload(files);
          }).catch(e => {
          Log('quxiao')
          this.$refs.form.reset();
        })
    },

    async upload(files) {
      let loading = weuijs.loading("上传中");
      for (let i = 0, file = files[i], l = files.length; i < l; i++) {
        let ret
        if (file.type.includes('video')) {
          const data = await systemService.attaQiniuToken({
            attaModelType: this.attaModelType,
            fileType: 'VIDEO',
            originalName: file.name
          })
          const atta = await this.qiniuUplaod(file, data.token);
          ret = {code: 0, obj: {url: data.url + '/' + atta.key, type: 'VIDEO'}};
        } else
          ret = await uploadApi(file, (...args) => {
            Log('progress', args);
          })
        //let base64 = await readFile(file), originalName = file.name;
        //let ret = await api("nethos.system.atta.upload.image.base64", {base64, originalName})
        this.$emit("uploaded", ret);
      }
      loading.hide();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/public";

.uploader {
  @include w_h(0px, 0px);

  input {
    @include w_h(0px, 0px);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/upload.vue